import { render, staticRenderFns } from "./commissionDeclareExtra.vue?vue&type=template&id=15adc19d"
import script from "./commissionDeclareExtra.vue?vue&type=script&lang=js"
export * from "./commissionDeclareExtra.vue?vue&type=script&lang=js"
import style0 from "./commissionDeclareExtra.vue?vue&type=style&index=0&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports